module.exports = __webpack_public_path__ + "media/images/fb-white-icon-3b19e7d47ed1faa0fe1855dc0e0a6a6b.png";